import { render, staticRenderFns } from "./Benchmark.vue?vue&type=template&id=05713056"
import script from "./Benchmark.vue?vue&type=script&lang=js"
export * from "./Benchmark.vue?vue&type=script&lang=js"
import style0 from "./Benchmark.vue?vue&type=style&index=0&id=05713056&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/app/nuxt/components/Section.vue').default})
